import BaseStore from "@/v1/utils/BaseStore";

import { GET_USER_ME_START, GET_USER_ME_SUCCESS } from "./types";

const initialState = {
  me: {
    name: "",
    groups: [],
  },
};

const store = new BaseStore("users", initialState);

const reducer = {
  [GET_USER_ME_START]: state => ({
    ...state,
    me: {
      ...state.me,
      loading: true,
    },
  }),
  [GET_USER_ME_SUCCESS]: (state, payload) => ({
    ...state,
    me: {
      ...state.me,
      ...payload.info,
    },
  }),
};

export default store.reducer(reducer);
